import * as actions from './actions'
import * as getters from './getters'
import * as types from './types'

const state = {
  previewInfo: {} // 活动预览所需数据
}
const mutations = {
  [types.SET_PREVIEW_INFO] (state, data) {
    state.previewInfo = data
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}
